module.exports = __webpack_public_path__ + "static/media/cpp.018e54b5.svg";